import { useToast } from "vue-toastification";
import { getDeviceInfo } from "@/helpers/helper";
import { redirectToSsoSignIn } from "@/helpers/navigation";

const toast = useToast();
import axios from "axios";
import { reactive } from "vue";
import router from "@/router";
const BASE_URL = window.location.origin;

let BACKEND_URL = "";
let toastShown = false;

// Filled from GET /auth/me (see stores/auth). Reactive so the menu, route
// guard and v-can buttons follow the signed-in user's permissions.
const session = reactive({
  user: null,
  permissions: [],
  roles: [],
  modules: [],
  sso_url: null,
});

export const setSession = (data = {}) => {
  session.user = data.user ?? null;
  session.permissions = Array.isArray(data.permissions) ? data.permissions : [];
  session.roles = Array.isArray(data.roles) ? data.roles : [];
  session.modules = Array.isArray(data.modules) ? data.modules : [];
  session.sso_url = data.sso_url ?? null;
};

export const clearSession = () => {
  session.user = null;
  session.permissions = [];
  session.roles = [];
  session.modules = [];
};

export const getSession = () => session;

// Sign-in endpoints answer 401 for a wrong password/OTP — that is the
// form's error to show, not an expired session.
const AUTH_ENDPOINTS = ["auth/login", "auth/sso/verify", "auth/mfa/"];

// A 401 only means "session expired" for someone who was signed in; on a
// first visit the router guard already sends the user to sign in.
const isExpiredSession = (error) =>
  error.response?.status === 401 &&
  session.user != null &&
  !AUTH_ENDPOINTS.some((endpoint) => error.config?.url?.startsWith(endpoint));

const http = () => {
  const apiClient = axios.create({
    baseURL: resolveUrl(BASE_URL),
    withCredentials: true,
    validateStatus: (status) => status >= 200 && status < 300,
  });

  // --- REQUEST INTERCEPTOR TO ADD DEVICE INFO + THE SPA HEADER ---
  // The sign-in travels in an HttpOnly cookie the API sets (withCredentials
  // sends it), shared by every tab. The API accepts that cookie only with
  // this header, which a page on another origin can't add (RCS-149).
  apiClient.interceptors.request.use((config) => {
    config.headers["X-Device-Info"] = JSON.stringify(getDeviceInfo());
    config.headers["X-Requested-With"] = "XMLHttpRequest";

    return config;
  });

  apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (isExpiredSession(error)) {
        clearSession();
        if (!toastShown) {
          toast.error("Your session has expired. Please sign in again.");
          toastShown = true;
          setTimeout(() => {
            toastShown = false;
          }, 5000);
        }
        redirectToSsoSignIn();
      }
      return Promise.reject(error);
    },
  );
  return apiClient;
};

export const resolveUrl = (origin) => {
  switch (origin) {
    case "http://localhost:5173":
    case "http://localhost:5177":
      return "http://localhost:8001/api/v1/";
    case "https://dev.rac.demulla.co.ke":
      return "https://devrac.api.demulla.co.ke/api/v1/";
    case "https://staging.rac.demulla.co.ke":
      return "https://stagingrac.api.demulla.co.ke/api/v1/";
    case "https://rac.demulla.co.ke":
      return "https://core.rac.demulla.co.ke/api/v1/";
    default:
      return "https://core.rac.demulla.co.ke/api/v1/";
  }
};
export default http;
